import { Injectable, inject } from '@angular/core';
import { TslApiService, TslSessionService } from 'projects/aztalena-core/src/public-api';
import { Observable } from 'rxjs';
import { UserInfo } from './user-info';

export interface AuthTokens {
  access_token: string;
  refresh_token: string;
}

export interface AuthTokensWithUser extends AuthTokens {
  user: UserInfo;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private api = inject(TslApiService);
  private session = inject(TslSessionService);

  signIn(username: string, password: string): Observable<AuthTokensWithUser> {
    return this.api.post('auth/sign-in', { username, password });
  }

  refreshToken(): Observable<AuthTokens> {
    return this.api.post('auth/refresh-token', { refreshToken: this.session.refreshToken });
  }
}
